import { MapPin, Phone, Mail, Globe, Download } from "lucide-react";
import { footer, site } from "@/data/content";
import { Emblem } from "@/components/Emblem";

const Footer = () => (
  <footer className="bg-fw-navy text-white" data-testid="footer">
    <div className="mx-auto max-w-7xl px-5 md:px-8 py-16">
      <div className="grid gap-10 md:grid-cols-3">
        <div>
          <div className="flex items-center gap-3">
            <Emblem className="h-12 w-10" />
            <div>
              <p className="font-technical uppercase font-bold text-lg leading-none">FF Dingharting</p>
              <p className="font-body text-xs text-fw-gold tracking-widest uppercase">Gegründet 1874</p>
            </div>
          </div>
        </div>

        <div className="font-body text-sm text-white/70 space-y-4">
          <p className="font-technical uppercase tracking-widest text-fw-gold text-xs">
            Kontakt/ Impressum
          </p>
          <p className="mt-5 font-body text-sm text-white/60 max-w-xs">{footer.name}</p>
          <p className="mt-5 font-body text-sm text-white/60 max-w-xs">
          {footer.responsible}<br />
          {footer.board}<br />
          {footer.commander}
          </p>
          <p className="flex items-start gap-3">
            <MapPin className="h-5 w-5 text-fw-red shrink-0" />
            {footer.adresse}
          </p>
          <p className="flex items-start gap-3">
            <Phone className="h-5 w-5 text-fw-red shrink-0" />
            <span><a href={`tel:${footer.telefon.replace(/\s/g, "")}`} className="hover:text-fw-gold">{footer.telefon}</a><br /><span className="text-xs text-white/40">{footer.telefonHinweis}</span></span>
          </p>
          <p className="flex items-start gap-3"><Mail className="h-5 w-5 text-fw-red shrink-0" /> <a href={`mailto:${footer.email}`} className="hover:text-fw-gold break-all">{footer.email}</a></p>
          <p className="flex items-start gap-3"><Globe className="h-5 w-5 text-fw-red shrink-0" /> <a href={footer.websiteUrl} target="_blank" rel="noopener noreferrer" className="hover:text-fw-gold">{footer.website}</a></p>
        </div>

        <div className="md:text-right">
          <p className="font-heritage italic text-2xl text-fw-gold">„Mehr als 150 Jahre im Dienst der Gemeinschaft.“</p>
        </div>
      </div>

      <div className="mt-12 border-t border-white/10 pt-6 flex flex-col md:flex-row justify-between gap-3 font-body text-xs text-white/40">
        <p>© {new Date().getFullYear()} {footer.name}</p>
        <p>{footer.impressum}</p>
      </div>
    </div>
  </footer>
);

export default Footer;
